import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom"; // optional, if you have a separate settings page

export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Check localStorage to see if user already accepted
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setShow(true); // show popup immediately
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "true");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center">
      <div className="bg-white p-6 rounded-lg max-w-md w-11/12 shadow-lg text-gray-900">
        <h2 className="text-2xl font-bold mb-4">Privacy & Cookies</h2>
        <p className="mb-6">
          We use cookies to enhance your browsing experience. By continuing, you agree to our use of cookies.
        </p>
        <div className="flex justify-end gap-3">
          <Link
            to="/cookie-settings"
            className="px-4 py-2 rounded-lg border border-gray-400 text-gray-700 hover:bg-gray-100 transition"
          >
            Privacy & Settings
          </Link>
          <button
            onClick={handleAccept}
            className="px-4 py-2 rounded-lg bg-[#f4b942] text-black font-semibold hover:bg-[#ffcc66] transition"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
